/* src/app/master-data/brands/sub-brands/sub-brands-list/sub-brands-list.component.css */
/*# sourceMappingURL=sub-brands-list.component-IX2FLGKM.css.map */
